import React from "react";
import { motion } from "framer-motion";

const EtInvestorsHero = () => {
  // First Created - 03 Oct 2025
  // Author - Atul Pandey

  return (
    <section
      id="investors-hero"
      className="h-screen flex items-center justify-center relative bg-gradient-to-br from-gray-900 via-black to-orange-900 text-white"
    >
      {/* Subtle overlay pattern */}
      <div className="absolute inset-0 opacity-15 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>

      {/* Content */}
      <motion.div
        className="text-center z-10 px-4 max-w-4xl"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        {/* Headline */}
        <motion.h1
          className="text-4xl md:text-6xl font-bold mb-6"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          
    Investing in the <span className="text-orange-500 animate-pulse">Future</span> of Leadership & AI-Driven <span className="text-orange-400">Growth</span>.
  
  
          {/* Investing in the Future of Leadership & AI-Driven Growth */}
        </motion.h1>

        {/* Subtext */}
        <motion.p
          className="text-lg md:text-xl text-gray-300 mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          Eternity is shaping the future of tech-led leadership with an AI-powered ecosystem that aligns human potential, performance, and profitability.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9 }}
        >
          <a
            href="#vision"
            className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg shadow-lg font-semibold"
          >
            Learn More
          </a>
          {/* <a
            href="#pitch"
            className="bg-white/10 hover:bg-white/20 px-6 py-3 rounded-lg font-semibold"
          >
            View Investor Pitch
          </a> */}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default EtInvestorsHero;